module.exports = __webpack_public_path__ + "static/img/add_icon.b82fc5c1.svg";